import { render, staticRenderFns } from "./divider-widget.vue?vue&type=template&id=0faf59b2&scoped=true&"
import script from "./divider-widget.vue?vue&type=script&lang=js&"
export * from "./divider-widget.vue?vue&type=script&lang=js&"
import style0 from "./divider-widget.vue?vue&type=style&index=0&id=0faf59b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf59b2",
  null
  
)

export default component.exports